var exports = {
  "kL": "x4c3adb35--8f6d99--container",
  "_8": "x4c3adb35--8f6d99--img",
  "p2": "x4c3adb35--8f6d99--text-info",
  "qU": "x4c3adb35--8f6d99--one-column",
  "Cv": "x4c3adb35--8f6d99--two-column",
  "$p": "x4c3adb35--8f6d99--services",
  "oJ": "x4c3adb35--8f6d99--work",
  "UU": "x4c3adb35--8f6d99--name",
  "s6": "x4c3adb35--8f6d99--agent-name",
  "Tq": "x4c3adb35--8f6d99--participations",
  "qS": "x4c3adb35--8f6d99--badge",
};

module.exports = exports;
